export default {
  darkBeige: '#a59a8d',
  white: '#ffffff'
}


/** WEBPACK FOOTER **
 ** ./src/colors.js
 **/